import { render } from "./main.vue?vue&type=template&id=4fe5ca8c"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"
script.render = render

export default script